export const containerMotion = {
    initial: {},
    animate: {
        transition: {
            delay: .7,
            staggerChildren: .2,
            delayChildren: .5,
        }
    },
    exit: {}
}

export const cardMotion = {
    initial: {
        opacity: 0,
        y: 10
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.99, 0.15, 0, 0.86],
        }
    },
    exit: {
        opacity: 0,
        x: -30,
        transition: {
            ease: [0.99, 0.15, 0, 0.86],
        }
    }
}